import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { TodayPage } from './TodayPage'

export const routes: RouteObject[] = [{ path: '/', element: <TodayPage /> }]

export const nav: NavItem[] = [{ path: '/', label: 'Сегодня', icon: 'today', mobile: 'tab', order: 10 }]
